<template>

  <t-page>

    <t-page-form multi-cards :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template #default="{status}">

        <t-input v-model="form.employeeId" hidden/>

        <b-row>

          <t-input v-model="form.name"  cols="9" :add-error="error.name" label="Nome" required/>

          <t-input v-model="form.employeeCodeLabel" v-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_MANUAL"
                   :add-error="error.employeeCodeLabel" upper cols="3"
                   label="Cód. Funcionário"
                   code-label
                   help="Código inserido manualmente conforme configurado em Recursos Humanos > Configurações > Parâmetros"
                   required/>

          <t-input v-model="form.employeeCodeLabel"
                   v-else-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_AUTOMATIC_DEFAULT"
                   :add-error="error.employeeCodeLabel" upper cols="3"
                   fixed
                   label="Cód. Funcionário"
                   help="Código inserido automaticamente conforme configurado em Recursos Humanos > Configurações > Parâmetros"
          />


        </b-row>

        <t-input v-model="form.companyId"
                 :options="companyOptions"
                 required
                 label="Empresa" select/>

        <t-input v-model="form.roleId"
                 :options="roleOptions"
                 label="Função" select required/>

        <t-page-form-field-customized
            :command="command" :status="status" :user-auth="userAuth"
            :fields-customizable="entityFieldCustomized('page')"
            :primary-key="form.employeeId" :foreign-key="currentPage.pageId" :busy="!pageFormIsLoaded"
            :primary-key-column="fieldKey" foreign-key-column="pageId"
        />

        <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

        <t-input-status v-model="form.status"/>


      </template>


    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import roleService from "@/services/modules/employee/Role.service";
import companyService from "@/services/modules/admin/Company.service";
import SettingType from "@/model/types/resource/SettingType";


export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'EmployeeForm',
  data() {
    return {
      SettingType,
      path: "", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: true,
      fieldKey: "employeeId",
      form: {
        employeeId: 0,
        companyId: 0,
        roleId: 0,
        employeeCodeLabel: "",
        name: "",
        note: "",
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
        employeeCodeLabel: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      modeCodeLabel: "",
      companyOptions: [],
      roleOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

    },
    async mountedContinued() {

      this.modeCodeLabel = this.getRenderRule(SettingType.render.RENDER_TAG_COD_LABEL)

      await companyService.selectList().then((list) => {
        this.companyOptions = list
      }).catch(error => this.responseError(error))

      await roleService.selectList().then((list) => {
        this.roleOptions = list
      }).catch(error => this.responseError(error))

      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },

}
</script>
